/// <reference path='../types/index.d.ts'/>

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { App } from './App';

ReactDOM.render(<App />, document.getElementById("root"));
